import { Avatar, Box, Slider, styled } from "@mui/material";
import { TIPPSPIEL_BOX_SHADOW } from "../../../../../styles";

export const SectionContainer = styled(Box)({
    borderRadius: "8px",
    padding: "24px 0",
    background: `url(${process.env.REACT_APP_CDN_ENDPOINT}/external/tippspiel/media/backgroundSliderPoll.webp)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
});

export const SliderContainer = styled(Box)({
    borderRadius: "8px",
    backgroundColor: "var(--community-color-snow-white)",
    width: "80%",
    height: "80px",
    boxShadow: TIPPSPIEL_BOX_SHADOW,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
});

export const RatingSlider = styled(Slider)<{ value: number }>(({ value }) => ({
    width: "80%",
    maxHeight: "80px",
    marginBottom: "0px",
    height: "90%",
    " .MuiSlider-rail": {
        height: "8px",
        borderRadius: "90px",
        backgroundColor: "var(--community-color-transparent-black-05)",
        opacity: "1",
    },
    " .MuiSlider-track": {
        height: "8px",
        color: "var(--community-color-error-red)",
    },
    " .MuiSlider-thumb": {
        width: 32 + value * 1.4 + "px",
        height: 32 + value * 1.4 + "px",
        "&::before": {
            boxShadow: "none",
        },
        "&.Mui-active": {
            boxShadow: "none",
        },
    },
    " .MuiSlider-markLabel": {
        height: "80%",
        top: "10%",
    },
}));

export const RatingThumbAvatar = styled(Avatar)({
    backgroundColor: "var(--community-color-snow-white)",
    boxShadow: TIPPSPIEL_BOX_SHADOW,
    position: "absolute",
    top: "50%",
    transform: "translate(0, -50%)",
});

export const AvatarMarkerContainer = styled(Box, {
    shouldForwardProp: (propName: PropertyKey) => propName !== "scaleFactor",
})<{ scaleFactor: number }>(({ scaleFactor }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    div: {
        width: "calc(32px + " + scaleFactor * 1.2 + "px)",
        height: "calc(32px + " + scaleFactor * 1.2 + "px)",
    },
}));

export const PostPollRateContent = styled(Box)({
    paddingBottom: "24px",
    width: "80%",
});
